import { getNumberOrZero } from './utils';

interface ProductWithOrderNumber {
	metadata?: {
		order_number?: string | null;
	} | null;
}

export const sortStripeProductsByOrderNumber = <T extends ProductWithOrderNumber>(
	a: T | null,
	b: T | null
) => {
	if (!a || !b) {
		return 0;
	}
	return getNumberOrZero(a.metadata?.order_number) - getNumberOrZero(b.metadata?.order_number);
};
